export enum NodeType {
    Root,
    Organization,
    Department,
    Group,
    Borehole,
}

export interface INode {
    name: string;
    type: NodeType;
    description: string | null;
}

export interface DbNode extends INode {
    node_id: number;
    parent_id: number | null;
}

export interface CreateNode extends INode {
    parent_id: number;
}

export const orderColumns = ['node_id', 'name', 'type'];

export function isDbNode(value: unknown): value is DbNode {
    if (typeof value !== 'object' || value === null) return false;
    const v = value as Record<string, unknown>;
    return typeof v.node_id === 'number'
        && typeof v.name === 'string'
        && typeof v.type === 'number'
        && (v.parent_id === null || typeof v.parent_id === 'number');
}
